import domain from './domain';

export interface ICookieConfig {
  secure: boolean,
}

const cookieConfig: ICookieConfig = {
  secure: domain.protocol === 'https:', // Set secured flag for cookie only if https
};

export default cookieConfig;
